import React from 'react';

const PerformanceCard = ({ 
  title, 
  value, 
  unit = '', 
  change, 
  changeLabel, 
  icon, 
  color = 'green', 
  onClick,
  animateValue = false 
}) => {
  const colorClasses = {
    green: {
      bg: 'bg-green-50',
      border: 'border-green-200',
      text: 'text-green-800',
      icon: 'text-green-600'
    },
    blue: {
      bg: 'bg-blue-50',
      border: 'border-blue-200',
      text: 'text-blue-800',
      icon: 'text-blue-600'
    },
    purple: {
      bg: 'bg-purple-50',
      border: 'border-purple-200',
      text: 'text-purple-800',
      icon: 'text-purple-600'
    },
    orange: {
      bg: 'bg-orange-50',
      border: 'border-orange-200',
      text: 'text-orange-800',
      icon: 'text-orange-600'
    },
    red: {
      bg: 'bg-red-50',
      border: 'border-red-200',
      text: 'text-red-800',
      icon: 'text-red-600'
    }
  };

  const styles = colorClasses[color] || colorClasses.green;

  const formatValue = (val) => {
    if (typeof val === 'number') {
      return val.toLocaleString('fr-FR');
    }
    return val?.toLocaleString?.() || val;
  };

  const getChangeIcon = () => {
    if (!change) return '';
    const numChange = typeof change === 'string' ? parseFloat(change.replace(/[^-\d.]/g, '')) : change;
    if (numChange > 0) return '▲';
    if (numChange < 0) return '▼';
    return '';
  };

  const getChangeColor = () => {
    if (!change) return 'text-gray-500';
    const numChange = typeof change === 'string' ? parseFloat(change.replace(/[^-\d.]/g, '')) : change;
    if (numChange > 0) return 'text-green-600';
    if (numChange < 0) return 'text-red-600';
    return 'text-gray-500';
  };

  return (
    <div 
      className={`
        ${styles.bg} ${styles.border} 
        border-2 rounded-xl p-6 
        ${onClick ? 'cursor-pointer hover:shadow-lg transform hover:-translate-y-1' : ''} 
        transition-all duration-300 shadow-sm
      `}
      onClick={onClick}
    >
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-medium text-gray-600 truncate">{title}</h3>
        {icon && (
          <div className={`text-2xl ${styles.icon}`}>
            {icon}
          </div>
        )}
      </div>
      
      <div className="flex flex-col">
        <div className="flex items-baseline mb-2">
          <span 
            className={`text-3xl font-bold ${styles.text} ${animateValue ? 'animate-pulse' : ''}`}
            style={{ fontFeatureSettings: '"tnum"' }}
          >
            {formatValue(value)}
          </span>
          {unit && <span className="text-lg text-gray-500 ml-2">{unit}</span>}
        </div>
        
        {(change || changeLabel) && (
          <div className="flex items-center text-sm">
            <span className={`${getChangeColor()} font-medium flex items-center`}>
              {getChangeIcon() && <span className="mr-1">{getChangeIcon()}</span>}
              {change}
            </span>
            {changeLabel && <span className="text-gray-500 ml-2">{changeLabel}</span>}
          </div>
        )}
      </div>
    </div>
  );
};

export default PerformanceCard;